import { useQuery } from "react-query";
import { getOnboarding } from "../../../../../services/vmApi";

export function useGetOnboarding(companyCode) {
  return useQuery(
    ["onboarding", companyCode],
    () => getOnboarding(companyCode).then((res) => res.data?.data || res.data),
    {
      enabled: !!companyCode,
      refetchOnWindowFocus: false,
    }
  );
}
